
export  function  getUrl() {
    return"https://semi.jdhwe.xyz"   //https://api.jdehr.xyz  http://192.168.5.7:8071

}

 